import { render, staticRenderFns } from "./PaginatedCleanerSchedules.vue?vue&type=template&id=5cb64eb7&scoped=true"
import script from "./PaginatedCleanerSchedules.vue?vue&type=script&lang=js"
export * from "./PaginatedCleanerSchedules.vue?vue&type=script&lang=js"
import style0 from "./PaginatedCleanerSchedules.vue?vue&type=style&index=0&id=5cb64eb7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb64eb7",
  null
  
)

export default component.exports